import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import { Tooltip } from "react-tooltip";
import editIcon from "../assets/images/edit2.png";
import deleteIcon from "../assets/images/delete2.png";
import ArrowLeft from "../assets/images/left-arrow.png";
import NotesIcon from "../assets/images/notes-icon.png";
// import ArrowDown from "../assets/images/chevron-down.svg";
// import ArrowUp from "../assets/images/chevron-up.svg";
import ReportIcon from "../assets/images/report.png";
import clockPlus from "../assets/images/clock-plus.png";
import {
  deleteTimeSheetEntry,
  getMyTimeSheetDetails,
  getTimeSheetByWeek,
  updateMyTimeCardStatus,
  getDailySummaryDetails,
  getWeeklyTotals,
  getAllProjectList,
} from "../API";
import {
  convertDateToUserTimezone,
  convertMinutesToHours,
  getDayName,
  getStartEndDate,
  slashSpace,
  subtractAndAbs,
} from "../utils/utils";
import { isChecklistApproverFlag, getReviewableCrewIds } from "../utils/auth";
import { toast } from "react-toastify";
import EditUserTimeCard from "../components/EditUserTimeCard";
import EditEquipmentTimeCard from "../components/EditEquipmentTimeCard";
import Loader from "./Loader";
import ItalicIcon1 from "../assets/images/info.png";
import "react-tooltip/dist/react-tooltip.css";
import TemporaryTimeEntryWarning from "../components/TemporaryTimeEntryWarning";
import Notes from "../components/modal/Notes";
import AdditionalTimeEntryModal from "../components/modal/AdditionalTimeEntryModal";

export const ReviewTimeCard = () => {
  const navigate = useNavigate();
  const [, setWeeklyTotals] = useState([]);
  // const [projectDetails, setProjectDetails] = useState();
  const [dailySummaryDetails, setDailySummaryDetails] = useState({});
  const [timeSheetDetails, setTimeSheetDetails] = useState({});
  const [timeSheetWeekDetails, setTimeSheetWeekDetails] = useState({});
  const [equipmentTimeSheet, setEquipmentTimeSheet] = useState({});
  // const [itemVisibility, setItemVisibility] = useState({});
  const [selectedUserValue, setSelectedUserValue] = useState({});
  const [selectedEquipmentValue, setSelectedEquipmentValue] = useState({});
  const [, setShowAddTimeButton] = useState(false);
  const [addUserEditModal, setAddUserEditModal] = useState(false);
  const [addEquipmentEditModal, setAddEquipmentEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isTempProject, setIsTempProject] = useState(false);
  const [tempProjectName, setTempProjectName] = useState("");
  const [notes, setNotes] = useState("");
  const [projectOptions, setProjectOptions] = useState([]);
  const [isAdditionalEntryModalOpen, setIsAdditionalEntryModalOpen] =
    useState(false);
  const [selectedAdditionalUserEntry, setSelectedAdditionalUserEntry] =
    useState({});
  const [
    selectedAdditionalEquipmentEntry,
    setSelectedAdditionalEquipmentEntry,
  ] = useState({});

  const { id, crew_id } = useParams();

  const role_id = JSON.parse(localStorage.getItem("role_id"));
  const role_name = localStorage.getItem("role_name");

  // Checklist approvers can VIEW any crew's timecard, but edit/delete/approve
  // stay confined to the crews their native role reviews. Fail closed (empty
  // scope) for flagged users until their reviewable crews are loaded;
  // reviewableCrewIds stays null (unrestricted) for everyone else.
  const isChecklistApprover = isChecklistApproverFlag();
  const [reviewableCrewIds, setReviewableCrewIds] = useState(
    isChecklistApprover ? new Set() : null
  );
  const canMutateTimeCard =
    !reviewableCrewIds || reviewableCrewIds.has(Number(crew_id));

  useEffect(() => {
    setShowAddTimeButton(true);
    getDetailsofCard();

    if (isChecklistApprover) {
      getReviewableCrewIds(role_name, localStorage.getItem("user_id")).then(
        (crewIds) => setReviewableCrewIds(crewIds)
      );
    }
  }, []);

  const getTimeSheetWeekDetails = async (timeSheetData) => {
    const data = {
      week: timeSheetData?.week,
      crew_id: timeSheetData?.crew_id,
    };

    // For User Time Cards
    await getTimeSheetByWeek(data, 1).then((res) => {
      setShowAddTimeButton(false);
      setTimeSheetWeekDetails(res?.data);
      setIsLoading(false);
      const isTempUser = res?.data?.find(
        (ele) => ele?.project_type === "webtime"
      );
      if (isTempUser) {
        setIsTempProject(true);
        setTempProjectName(isTempUser?.project_name);
      }
    });
    // For Equipment Time Cards
    await getTimeSheetByWeek(data, 2).then((res) => {
      setShowAddTimeButton(false);
      setEquipmentTimeSheet(res?.data);
      setIsLoading(false);
      const isTempEquipment = res?.data?.find(
        (ele) => ele?.project_type === "webtime"
      );
      if (isTempEquipment) {
        setIsTempProject(true);
        setTempProjectName(isTempEquipment?.project_name);
      }
    });

    await getWeeklyTotals(data).then((res) => {
      const groupedData = _.groupBy(res?.data, "task");
      // const weeklyMappingData = mapEntriesToTableData(groupedData);
      setWeeklyTotals(groupedData);
    });
  };

  const getDetailsofCard = async () => {
    const queryParams = `id=${id}`;

    await getMyTimeSheetDetails(queryParams).then(async (res) => {
      setIsLoading(true);
      if (res?.status === 200) {
        setTimeSheetDetails(res?.data[0]);
        getTimeSheetWeekDetails(res?.data[0]);
        await getAllProjectList().then((res) => {
          const projectDropDownOptions = res?.data?.map((item) => {
            return {
              label: `(${item?.acumatica_project_id}) ${item?.description}`,
              value: item,
            };
          });
          setProjectOptions(projectDropDownOptions);
        });
      }
    });
  };

  const getPerDayDetails = (data) => {
    return _.groupBy(data, "time_entry_date");
  };

  // const toggleVisibility = (index) => {
  //   setItemVisibility((prevVisibility) => ({
  //     ...prevVisibility,
  //     [index]: !prevVisibility[index],
  //   }));
  // };

  // console.log("setItemVisibility", itemVisibility);

  const fetchDailySummaryData = async (orderedDates) => {
    let dailySummaryObj = {};
    Object.keys(orderedDates).forEach(async (date) => {
      const time_entry_date = date?.split("T")[0];
      const dailySummaryPayload = {
        crew_id,
        time_entry_date,
      };
      await getDailySummaryDetails(dailySummaryPayload).then((res) => {
        dailySummaryObj[date] = res?.data;
        setDailySummaryDetails((previousState) => ({
          ...previousState,
          [date]: res?.data,
        }));
        // setDailySummaryDetails(dailySummaryObj);
      });
    });
  };


  const cachedUserValue = useMemo(() => {
    if (timeSheetWeekDetails?.length > 0) {
      const data = getPerDayDetails(timeSheetWeekDetails);
      const dates = JSON.parse(JSON.stringify(data));
      let orderedDates = {};
      _(dates)
        .keys()
        .sort()
        .each(function (key) {
          orderedDates[key] = dates[key];
        });
      fetchDailySummaryData(orderedDates);
      return orderedDates;
    } else {
      return {};
    }
  }, [timeSheetWeekDetails]);

  const cachedEquipmentValue = useMemo(() => {
    if (equipmentTimeSheet?.length > 0) {
      const data = getPerDayDetails(equipmentTimeSheet);
      const dates = JSON.parse(JSON.stringify(data));
      let orderedDates = {};
      _(dates)
        .keys()
        .sort()
        .each(function (key) {
          orderedDates[key] = dates[key];
        });

      return orderedDates;
    } else {
      return {};
    }
  }, [equipmentTimeSheet]);

  const cachedAllEntries = Object.keys({
    ...cachedUserValue,
    ...cachedEquipmentValue,
  }).map((date) => {
    const employees = cachedUserValue[date] || [];
    const equipment = cachedEquipmentValue[date] || [];
    return {
      [date]: [...employees, ...equipment].sort(),
    };
  });
  cachedAllEntries.sort((a, b) => {
    const dateA = Object.keys(a)[0];
    const dateB = Object.keys(b)[0];
    return new Date(dateA) - new Date(dateB);
  });

  const CardData = useMemo(() => {
    let cardStartDate = "";
    let cardEndDate = "";
    if (timeSheetDetails && Object?.keys(timeSheetDetails)?.length) {
      const week = timeSheetDetails?.week;
      const year = week?.split("-")[0];
      const cardWeek = week?.split("W")[1];
      const { startDate, endDate } = getStartEndDate(year, cardWeek);
      cardStartDate = startDate;
      cardEndDate = endDate;
    }
    return { cardStartDate, cardEndDate };
  }, [timeSheetDetails]);

  const onDeleteClick = async (item) => {
    await deleteTimeSheetEntry(item?.time_entry_id)
      .then((res) => {
        if (res?.status === 204) {
          getDetailsofCard();
          toast.success("Entry Deleted Successfully");
        }
      })
      .catch(() => toast.error("Unable to delete entry"));
  };

  const onUserEditClick = (item) => {
    if (item) {
      setSelectedUserValue(item);
    }
    setAddUserEditModal(true);
  };

  const onEditTeamEntry = (item) => {
    if (item) {
      setSelectedEquipmentValue(item);
    }
    setAddEquipmentEditModal(true);
  };

  const onClickApprove = async () => {
    if (!isTempProject) {
      await updateMyTimeCardStatus(
        {
          time_sheet_status_id: 4,
        },
        id
      ).then((res) => {
        if (res?.status === 200) {
          toast.success("Time sheet approved");
          navigate("/review-timesheet");
        }
      });
    }
  };

  const onClickDownloadReport = () => {
    const payload = {
      week: timeSheetDetails?.week,
      crew_id: timeSheetDetails?.crew_id,
    };
    const encodedPayload = btoa(JSON.stringify(payload));
    const params = new URLSearchParams({ payload: encodedPayload });

    navigate(`/reports/3?${params.toString()}`);
  };

  const onClickReturn = async () => {
    await updateMyTimeCardStatus(
      {
        time_sheet_status_id: 2,
      },
      id
    ).then((res) => {
      if (res?.status === 200) {
        toast.success("Time sheet returned to submitted state");
        navigate("/review-timesheet");
      }
    });
  };

  const onClickNotes = (item) => {
    setNotes(item?.notes);
  };

  const onApproveStatusChange = async (item) => {
    const payload = {
      [item]: !timeSheetDetails[item],
    };
    await updateMyTimeCardStatus(payload, timeSheetDetails?.id).then((res) => {
      getDetailsofCard();
    });
  };

  const ReturnAndApproveComponent = () => {
  if (
    timeSheetDetails?.time_sheet_status_id === 0 ||
    timeSheetDetails?.time_sheet_status_id === 1
  ) {
    return null; // Don't render anything
  }

  return (
    <>
      <button
        className="primary-btn-less-width back-btn me-3"
        onClick={() => onClickReturn()}
        style={{ backgroundColor: "#ff5252" }}
      >
        Return
      </button>
      <button
        data-bs-toggle={isTempProject ? "modal" : undefined}
        data-bs-target={isTempProject ? "#tempProjectWarning" : undefined}
        className="primary-btn-less-width"
        onClick={() => onClickApprove()}
        style={{
          backgroundColor: "green",
          border: "none",
          color: "white",
        }}
      >
        Approve
      </button>
    </>
  );
};

  const ApproveAndUnApproveComponent = () => {
    if (
    timeSheetDetails?.time_sheet_status_id === 0 ||
    timeSheetDetails?.time_sheet_status_id === 1
  ) {
    return null; // Don't render anything
  }
    return (
      <>
        {(role_name === "Ops Manager" ||
          role_name === "Foreman OpsManager") && (
          <button
            className={`primary-btn-less-width ${
              timeSheetDetails?.is_ops_manager_approved
                ? "timesheet-un-approve"
                : "timesheet-approve"
            } `}
            onClick={() => onApproveStatusChange("is_ops_manager_approved")}
          >
            {timeSheetDetails?.is_ops_manager_approved
              ? "Unapprove"
              : "Approve"}
          </button>
        )}
        {(role_name === "General Foreman" ||
          role_name === "Foreman GeneralForeman" || role_name === "GeneralForeman Ops Manager") && (
          <button
            className={`primary-btn-less-width ${
              timeSheetDetails?.is_general_manager_approved
                ? "timesheet-un-approve"
                : "timesheet-approve"
            } `}
            onClick={() => onApproveStatusChange("is_general_manager_approved")}
          >
            {timeSheetDetails?.is_general_manager_approved
              ? "Unapprove"
              : "Approve"}
          </button>
        )}
      </>
    );
  };

  const onClickAdditionalTimeEntry = (item) => {
    setIsAdditionalEntryModalOpen(true);
    if (item?.time_entry_type_id === 1) {
      setSelectedAdditionalUserEntry(item);
      setSelectedAdditionalEquipmentEntry({});
    } else {
      setSelectedAdditionalEquipmentEntry(item);
      setSelectedAdditionalUserEntry({});
    }
  };

  const closeAdditionalTimeEntryModal = () => {
    setIsAdditionalEntryModalOpen(false);
  };

  return (
    <div className="crew-mgmt">
      {!isLoading ? (
        <>
          {/* <button
            type="button"
            className="btn btn-secondary"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Tooltip on top"
          >
            Tooltip on top
          </button> */}
          <div className="timecard-header">
            <div className="timecard-header-main">
              <button
                type="button"
                className="timecard-back-btn"
                aria-label="Go back"
                onClick={() => navigate(-1)}
              >
                <img alt="" src={ArrowLeft} />
              </button>
              <div className="timecard-title">
                <h1 className="timecard-crew-id">
                  {timeSheetDetails?.crew?.virtual_id}
                </h1>
                {timeSheetDetails?.week && (
                  <div className="timecard-meta">
                    <span className="timecard-week-pill">
                      {timeSheetDetails?.week}
                    </span>
                    <span className="timecard-dates">
                      {CardData?.cardStartDate}-{CardData?.cardEndDate}
                    </span>
                  </div>
                )}
              </div>
              {(timeSheetDetails?.crew?._foreman ||
                timeSheetDetails?.crew?._general_foreman) && (
                <div className="timecard-crew-roles">
                  {timeSheetDetails?.crew?._foreman && (
                    <div className="timecard-role">
                      <span className="timecard-role-tag">FM</span>
                      {timeSheetDetails?.crew?._foreman}
                    </div>
                  )}
                  {timeSheetDetails?.crew?._general_foreman && (
                    <div className="timecard-role">
                      <span className="timecard-role-tag">GF</span>
                      {timeSheetDetails?.crew?._general_foreman}
                    </div>
                  )}
                </div>
              )}
            </div>
            {(Object.keys(dailySummaryDetails).length > 0 ||
              Object.keys(timeSheetDetails).length > 0 ||
              Object.keys(timeSheetWeekDetails).length > 0 ||
              Object.keys(equipmentTimeSheet).length > 0) && (
              <div className="timecard-actions">
                <button
                  disabled={isLoading}
                  className="primary-btn-outlined"
                  onClick={() => onClickDownloadReport()}
                >
                  Review Time Report
                </button>
                {canMutateTimeCard &&
                  (role_id === 1 && role_name === "Admin" ? (
                    <ReturnAndApproveComponent />
                  ) : (
                    <ApproveAndUnApproveComponent />
                  ))}
              </div>
            )}
          </div>

          {cachedAllEntries?.length > 0 &&
            cachedAllEntries?.map((dayDetails) => {
              const dateKey = _.findKey(dayDetails);
              const day = getDayName(convertDateToUserTimezone(dateKey));
              const teamHeaders = [
                "EE ID",
                "Name",
                "Project",
                "Task",
                "Cost Code",
                "Start",
                "Stop",
                "Lunch",
                "Total",
                "",
              ];
              const equipmentHeaders = [
                "Equip. No.",
                "Item",
                "Project",
                "Task",
                "Cost Code",
                "Start",
                "Stop",
                "Break",
                "Total",
                "Offline",
                "",
              ];

              return (
                <div className="crew-mgmt-card timecard-day-card" key={dateKey}>
                  <div className="timecard-day-heading">
                    <h3>{day}</h3>
                    <span>{dateKey}</span>
                  </div>
                  {cachedUserValue[dateKey]?.length > 0 && (
                    <>
                      <h2 className="heading timecard-section-heading">
                        Team Hours
                      </h2>
                      <div className="data-table-shell timecard-table-shell">
                        <table className="table table-striped tableV2 timecard-entry-table timecard-team-table">
                          <thead>
                            <tr>
                              {teamHeaders?.map((item, key) => (
                                <th
                                  scope="col"
                                  className="table-heading"
                                  key={key}
                                >
                                  {item}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {cachedUserValue[dateKey]?.map((item, key) => (
                              <tr
                                key={key}
                                className={
                                  item?.project_type === "webtime"
                                    ? "table-row-warning"
                                    : ""
                                }
                              >
                                <td className="record-id">
                                  <div>
                                    {item?.employee_id
                                      ? item?.employee_id
                                      : "NA"}
                                  </div>
                                </td>
                                <td className="timecard-person-name">
                                  <span className="icons">
                                    {item?.name}
                                    {item?.is_stepup_foreman && (
                                      <img
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "5px",
                                        }}
                                        className="my-anchor-element info-icon"
                                        src={ItalicIcon1}
                                        alt=""
                                      />
                                    )}
                                  </span>
                                </td>
                                <td className="timecard-project-cell">{`(${
                                  item?.project_number
                                }) ${slashSpace(item?.project_name)}`}</td>
                                <td>{slashSpace(item?.task)}</td>
                                <td>{item?.cost_code}</td>
                                <td>{item?.time_entry_in}</td>
                                <td>{item?.time_entry_out}</td>
                                <td>{item?.lunch ? item?.lunch : 0}</td>
                                <td className="timecard-total-cell">
                                  {subtractAndAbs(item?.hours, item?.lunch)}
                                  {item?.other_entries?.length > 0 ? "*" : ""}
                                </td>
                                <td className="action-icons">
                                  <div className="icons table-actions timecard-row-actions">
                                    {item?.other_entries?.length > 0 && (
                                      <img
                                        src={clockPlus}
                                        type="button"
                                        onClick={() =>
                                          onClickAdditionalTimeEntry(item)
                                        }
                                        alt=""
                                      />
                                    )}
                                    <img
                                      src={NotesIcon}
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#notesModal"
                                      onClick={() => onClickNotes(item)}
                                      alt=""
                                    />
                                    {canMutateTimeCard && (
                                      <>
                                        <img
                                          src={editIcon}
                                          data-bs-toggle="offcanvas"
                                          data-bs-target="#editUserSideModal"
                                          aria-controls="editUserSideModal"
                                          className="img-fluid edit-icon"
                                          onClick={() => onUserEditClick(item)}
                                          alt=""
                                        />
                                        <img
                                          src={deleteIcon}
                                          className="img-fluid del-icon"
                                          onClick={() => onDeleteClick(item)}
                                          alt=""
                                        />
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                  {cachedEquipmentValue[dateKey]?.length > 0 && (
                    <>
                      <h2 className="heading timecard-section-heading">
                        Equipment Hours
                      </h2>
                      <div className="data-table-shell timecard-table-shell">
                        <table className="table table-striped tableV2 timecard-entry-table timecard-equipment-table">
                          <thead>
                            <tr>
                              {equipmentHeaders?.map((item, key) => (
                                <th
                                  scope="col"
                                  className="table-heading"
                                  key={key}
                                >
                                  {item}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {cachedEquipmentValue[dateKey]?.map((item, key) => (
                              <tr
                                key={key}
                                className={
                                  item?.project_type === "webtime"
                                    ? "table-row-warning"
                                    : ""
                                }
                              >
                                <td className="record-id">
                                  <div>{item?.acumatica_id}</div>
                                </td>
                                <td className="timecard-person-name">
                                  {item?.name}
                                </td>
                                <td className="timecard-project-cell">{`(${
                                  item?.project_number
                                }) ${slashSpace(item?.project_name)}`}</td>
                                <td>{slashSpace(item?.task)}</td>
                                <td>
                                  {item?.cost_code ? item?.cost_code : "NA"}
                                </td>
                                <td>{item?.time_entry_in}</td>
                                <td>{item?.time_entry_out}</td>
                                <td>{item?.lunch ? item?.lunch : 0}</td>
                                <td className="timecard-total-cell">
                                  {subtractAndAbs(item?.hours, item?.lunch)}
                                  {item?.other_entries?.length > 0 ? "**" : ""}
                                </td>
                                <td>
                                  {convertMinutesToHours(item?.offline) || 0}
                                </td>
                                <td className="action-icons">
                                  <div className="icons table-actions timecard-row-actions">
                                    {item?.other_entries?.length > 0 && (
                                      <img
                                        src={clockPlus}
                                        type="button"
                                        onClick={() =>
                                          onClickAdditionalTimeEntry(item)
                                        }
                                        alt=""
                                      />
                                    )}
                                    <img
                                      src={NotesIcon}
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#notesModal"
                                      onClick={() => onClickNotes(item)}
                                      alt=""
                                    />
                                    {canMutateTimeCard && (
                                      <>
                                        <img
                                          data-bs-toggle="offcanvas"
                                          data-bs-target="#editEquipmentSideModal"
                                          aria-controls="editEquipmentSideModal"
                                          src={editIcon}
                                          className="img-fluid edit-icon"
                                          onClick={() => onEditTeamEntry(item)}
                                          alt=""
                                        />
                                        <img
                                          src={deleteIcon}
                                          className="img-fluid del-icon"
                                          onClick={() => onDeleteClick(item)}
                                          alt=""
                                        />
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          {/* {Object?.keys(weeklyTotals)?.length > 0 && */}
           {/* (
            <>
              <div className="crew-mgmt-card">
                <h2 className="title title2">Weekly Totals</h2>
                <table className="table table-striped timesheet-table">
                  <thead>
                    <tr>
                      {[
                        "Task",
                        "Cost Code",
                        "Labor Hours",
                        "Equipment Hours",
                      ]?.map((item, key) => (
                        <th scope="col" className="table-heading" key={key}>
                          {item}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  {/* <tbody>
                    {Object?.keys(weeklyTotals)?.map((entry) => (
                      <tr key={entry.cost_code}>
                        <td>{entry.task}</td>
                        <td>{entry.cost_code}</td>
                        <td>{entry.labor_hours}</td>
                        <td>{entry.equipment_hours}</td>
                      </tr>
                    ))}
                  </tbody> */}
                  {/* <tbody>
                    {Object?.keys(weeklyTotals)?.map((objKey) => {
                      return weeklyTotals[objKey]?.map((timeEntry, key) => (
                        <tr key={key}>
                          <td>{objKey}</td>
                          <td>{timeEntry.cost_code}</td>
                          <td>
                            {timeEntry.time_entry_type_id === 1
                              ? timeEntry.hours
                              : 0}
                          </td>
                          <td>
                            {timeEntry.time_entry_type_id === 2
                              ? timeEntry.hours
                              : 0}
                          </td>
                        </tr>
                      ));
                    })}
                  </tbody>
                </table> */}
              {/* </div> */}
            {/* </> */}
          {/* // ) */}
          {/* // } */}
          {/* <RightDrawerModal
        crew_id={timeSheetDetails?.crew_id}
        project_id={timeSheetDetails?.crew?.project_id}
        addCrewModal={addCrewModal}
        onModalClick={onModalClick}
        entryType={"user"}
        getTimeSheetWeekDetails={getTimeSheetWeekDetails}
        timeSheetDetails={timeSheetDetails}
      />
      <RightEquipmentDrawer
        crew_id={timeSheetDetails?.crew_id}
        project_id={timeSheetDetails?.crew?.project_id}
        addCrewModal={addEquipmentModal}
        onModalClick={onEquipmentModalClick}
        entryType={"equipment"}
        getTimeSheetWeekDetails={getTimeSheetWeekDetails}
        timeSheetDetails={timeSheetDetails}
      /> */}
          <Notes notes={notes} setNotes={setNotes} />
          {/* Defense in depth: keep the write-capable drawers out of the DOM
              entirely for scope-limited viewers, not just their triggers */}
          {canMutateTimeCard && (
            <>
              <EditUserTimeCard
                crew_id={timeSheetDetails?.crew_id}
                project_id={timeSheetDetails?.crew?.project_id}
                addCrewModal={addUserEditModal}
                selectedUserValue={selectedUserValue}
                onModalClick={onUserEditClick}
                entryType={"user"}
                getTimeSheetWeekDetails={getTimeSheetWeekDetails}
                timeSheetDetails={timeSheetDetails}
                projectOptions={projectOptions}
              />
              <EditEquipmentTimeCard
                crew_id={timeSheetDetails?.crew_id}
                project_id={timeSheetDetails?.crew?.project_id}
                addCrewModal={addEquipmentEditModal}
                selectedUserValue={selectedEquipmentValue}
                onModalClick={onUserEditClick}
                entryType={"equipment"}
                getTimeSheetWeekDetails={getTimeSheetWeekDetails}
                timeSheetDetails={timeSheetDetails}
                projectOptions={projectOptions}
              />
            </>
          )}
          <AdditionalTimeEntryModal
            isOpen={isAdditionalEntryModalOpen}
            closeModal={closeAdditionalTimeEntryModal}
            selectedUserEntry={selectedAdditionalUserEntry}
            selectedEquipmentEntry={selectedAdditionalEquipmentEntry}
          />
          <TemporaryTimeEntryWarning tempProjectName={tempProjectName} />
          {(Object.keys(dailySummaryDetails).length > 0 ||
            Object.keys(timeSheetDetails).length > 0 ||
            Object.keys(timeSheetWeekDetails).length > 0 ||
            Object.keys(equipmentTimeSheet).length > 0) && (
            <div className="d-flex justify-content-center">
              <button
                disabled={isLoading}
                className="primary-btn-less-width border-end me-3"
                onClick={() => onClickDownloadReport()}
              >
                <img className="report-logo" src={ReportIcon} alt="" /> Download
                report
              </button>
              <span className="border-end me-3"></span>
              {canMutateTimeCard &&
                (role_id === 1 && role_name === "Admin" ? (
                  <>
                    <ReturnAndApproveComponent />
                  </>
                ) : (
                  <>
                    <ApproveAndUnApproveComponent />
                  </>
                ))}
              {/* <button
                className="primary-btn-less-width back-btn me-3"
                onClick={() => onClickReturn()}
                style={{ backgroundColor: "#ff5252" }}
              >
                Return
              </button>
              <button
                data-bs-toggle={isTempProject && "modal"}
                data-bs-target={isTempProject && "#tempProjectWarning"}
                className="primary-btn-less-width"
                onClick={() => onClickApprove()}
                style={{
                  backgroundColor: "green",
                  border: "none",
                  color: "white",
                }}
              >
                Approve
              </button> */}
            </div>
          )}
          {/* <div className="add-icons text-end">
        <img src={eventIcon} className="img-fluid me-4" alt="" />
        <img src={userIcon} className="img-fluid" alt="" />
      </div> */}
          <Tooltip anchorSelect=".my-anchor-element" place="bottom-start">
            Step up foreman time entry
          </Tooltip>
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default ReviewTimeCard;